// Header component with navigation links
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../digiward.png';

const Header = ({ isSignedIn, handleSignOut }) => {
    return (
        <header className="header-nav">
            <div className="logo-container">
                <Link to="/">
                    <img src={logo} alt="Logo" className="logo" />
                    <span className="logo-text">𝒟𝐼𝒢𝐼𝒯𝒜𝐿 𝒲𝒜𝑅𝒟𝑅𝒪𝐵𝐸</span>
                </Link>
            </div>
            <nav className="nav-links">
                <Link to="/" className="nav-link"><i class="fa-solid fa-house"></i> <strong>𝐻𝑜𝓂𝑒</strong></Link>
                {isSignedIn && <Link to="/clothes" className="nav-link"><strong>𝒞𝓁𝑜𝓉𝒽𝑒𝓈</strong></Link>}
                {isSignedIn && <Link to="/outfits" className="nav-link"><strong>𝒪𝓊𝓉𝒻𝒾𝓉𝓈</strong></Link>}
                {isSignedIn && <Link to="/occasions" className="nav-link"><strong>𝒪𝒸𝒸𝒶𝓈𝒾𝑜𝓃𝓈</strong></Link>}
                {isSignedIn && <Link to="/travellists" className="nav-link"><strong>𝒯𝓇𝒶𝓋𝑒𝓁 𝐿𝒾𝓈𝓉𝓈</strong></Link>}
            </nav>
            <div className="nav-account-links">
                {isSignedIn && <Link to="/my-account" className="nav-link"><i className="fa-solid fa-user"></i> <strong>𝑀𝓎 𝒜𝒸𝒸𝑜𝓊𝓃𝓉</strong></Link>}
                {isSignedIn && <button onClick={handleSignOut} className="nav-button"><i class="fa-solid fa-right-from-bracket"></i> <strong>𝒮𝒾𝑔𝓃 𝒪𝓊𝓉</strong></button>}
                {!isSignedIn && <Link to="/signin" className="nav-link"><i class="fa-solid fa-right-to-bracket"></i> <strong>𝒮𝒾𝑔𝓃 𝐼𝓃</strong></Link>}
                {!isSignedIn && <Link to="/signup" className="nav-link"><i class="fa-solid fa-user-plus"></i> <strong>𝒮𝒾𝑔𝓃 𝒰𝓅</strong></Link>}
            </div>
        </header>
    );
};

export default Header;
